import React from 'react'
import ErrorBoundary from '../../../../../molecules/ErrorBoundary'
import FadeIn from '../../../../../molecules/Transitions/FadeIn'
import { ContentManagementView } from './ContentManagementView'

const ContentThingsTool = () => {
  return (
    <ErrorBoundary name='Client Content Tab'>
      <FadeIn>
        <ContentManagementView />
      </FadeIn>
    </ErrorBoundary>
  )
}

export default ContentThingsTool
